import { DFV_PLAY_VIEWED } from '../actions/dfvPlayViewedAction';

const updateDynamicFieldViewLive = (state = {}, action) => {
    const { datasource, type } = action;

    if (datasource === 'gumbo') {
        const { gamePk, liveData } = action.data;
        const { currentPlay, allPlays } = liveData?.plays;

        return {
            ...state,
            allPlays,
            currentPlay,
            gamePk,
            isSameGame: state?.gamePk === gamePk
        };
    } else if (type === DFV_PLAY_VIEWED) {
        const { index, gamePk } = action;
        return {
            ...state,
            viewedIndex: state?.gamePk === gamePk ? index : undefined
        };
    }
    return state;
};

export default updateDynamicFieldViewLive;
